import { HIT_TARGET, VERSION } from '../../config.js';
// Utils
import { debug } from './debug.js';

let dotInstance = null;

const service = 'idt';
const dotConfig = {
  service,
  load: false,
  mousedown: false,
  impress: false,
};

/**
 * Configures dotInstance when window.DOT.getNewInstance is available
 */
const configureDot = () => {
  if (window.DOT && window.DOT.getNewInstance) {
    dotInstance = window.DOT.getNewInstance();
    dotInstance.cfg(dotConfig);
    debug('DOT instance configured');
  }
};

/**
 * Gets identity object
 * @returns identity object
 */
const getIdentityObject = () => {
  if (window.sznIVA && window.sznIVA.IS) {
    const ids = window.sznIVA.IS.getIdentities({ cacheEnough: true, justSettled: false }, null, false);
    return window.sznIVA.IS.prepareIdsForBe(ids);
  }

  return {};
};

/**
 * Send a specific POST hit request.
 * @param {String} action - Action that is being logged.
 * @param {object} customData - data that will be added into hit data.
 * @param {boolean} consent has/doesn't have consent
 */
const sendHit = (action, customData, consent = null) => {
  // prepare hit data
  let hitData = { action };

  if (consent !== null) {
    hitData.hasConsent = consent.toString();
  }

  if (customData) {
    hitData = {
      ...hitData,
      ...customData,
    };
  }

  // try to config DOT
  if (!dotInstance) {
    configureDot();
  }

  // DOT instance created, send hit
  if (dotInstance) {
    dotInstance.hit('event', { data: hitData });
    debug('Hit was sent via dot instance - ', action);
    return;
  }

  if (!window.XMLHttpRequest) {
    return;
  }

  // creating hit manually
  const ids = getIdentityObject();
  const hit = {
    action: 'event',
    service,
    data: hitData,
    ptitle: document.title,
    url: document.location.href,
    ids,
    version: '1.0',
  };
  const sender = 'linkdecoration';
  const senderVersion = VERSION || 'undefined';

  const xhr = new XMLHttpRequest();

  let body = '';

  try {
    body = JSON.stringify(hit);
  } catch {
    return;
  }

  // Request preparation (method, url, asyncFlag).
  xhr.open('POST', HIT_TARGET, true);

  // Send the proper header information along with the request
  xhr.setRequestHeader('Content-Type', 'application/json');

  // Sender (Linkdecoration) information
  xhr.setRequestHeader('X-Client-Id', sender);
  xhr.setRequestHeader('X-Client-Version', senderVersion);

  // Required to send with cookies.
  xhr.withCredentials = true;

  // Send request
  xhr.send(body);
  debug('Hit was manually sent - ', action);
};

export { sendHit };
